import { useEffect, useState } from 'react'
import axios from "axios"
import { load } from '@cashfreepayments/cashfree-js'

const MOCK_ORDER_ID = "order_123456";
const MOCK_SESSION_ID = "session_demo_" + Math.random().toString(36).substr(2, 9);


const CashFreePayment = (props) => {

const {order_id,session_id} = props

const [orderId,setOrderId] = useState(null)
  let cashfree;

  let insitialzeSDK = async function () {

    cashfree = await load({
      mode: "sandbox",
    })
  }


  insitialzeSDK()


  useEffect(()=>{

  },[order_id,session_id])

  const getSessionId = async () => {
    try {
      setOrderId(MOCK_ORDER_ID)
      return MOCK_SESSION_ID
      //   let res = await axios.get("http://localhost:8000/payment")

      //   if(res.data && res.data.payment_session_id){


      //   }


    } catch (error) {
    }
  }


  const verifyPayment = async () => {
    try {

      let res = await axios.post("http://localhost:8000/verify", {
        orderId: orderId
      })

      if (res && res.data) {
        alert("payment verified")
      }

    } catch (error) {
    }
  }

  const handleClick = async (e) => {
    e.preventDefault()
    try {

      let sessionId = await getSessionId()
      let checkoutOptions = {
        paymentSessionId: sessionId,
        redirectTarget: "_modal",
      }

      cashfree.checkout(checkoutOptions).then((res) => {

        verifyPayment(order_id)
      })


    } catch (error) {
    }

  }
  return (
    <div><button onClick={handleClick}>
      Pay now
    </button></div>
  )
}

export default CashFreePayment